import { put, select, takeLatest } from 'redux-saga/effects'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { setInputRows } from '../../../../components/procedure/store/procedure.actions'
import { IProcedureState } from '../../../../components/procedure/store/procedure.types'
import { getImmobilizationSelector } from '../selectors'
import { ImmobilizationConstants } from '../store/immobilization.constants'
import { IImmobilizationState } from '../store/immobilization.types'

export function* setProcedureComplications() {
  const procedureState: IProcedureState = yield select(getProcedureStateSelector)
  const immobilizationState: IImmobilizationState = yield select(getImmobilizationSelector)
  const { inputRows } = procedureState
  const { procedureComplications } = immobilizationState
  inputRows.map((row) =>
    row.inputs.map((input) => {
      if (input.key === ImmobilizationConstants.SET_PROCEDURE_COMPLICATIONS) {
        //@ts-ignore
        input.props.savedValues = procedureComplications
      }
    })
  )
  yield put(setInputRows(inputRows))
}

export function* setProcedureComplicationsSaga() {
  yield takeLatest([ImmobilizationConstants.SET_PROCEDURE_COMPLICATIONS], setProcedureComplications)
}
